import { render, staticRenderFns } from "./SectionProperty.vue?vue&type=template&id=5d09b88c&"
import script from "./SectionProperty.vue?vue&type=script&lang=js&"
export * from "./SectionProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports